import styled from "styled-components";
import { Tab, Tabs } from "@blueprintjs/core";

import { useUrlSearch } from "@hooks";

import { SimpleMode } from "@pages/editor/components/SimpleMode/SimpleMode";

import { RuleEditor } from "./RuleEditor";

const TestPanel = styled.div`
  display: grid;
  grid-template-rows: minmax(0, 1fr) min-content;
`;

const SecondaryTestPanel = styled(TestPanel)`
  background-color: #ebf1f5;
`;

const TestPanelContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: min-content minmax(0, 1fr);
`;

type TAB_ID = "simple" | "advanced";

/**
 * Rule editor panel with simple and advanced tabs
 */
export const RuleEditorPanel = ({ defaultTab }: { defaultTab: TAB_ID }) => {
  const { search, setSearch } = useUrlSearch();
  const selectedTabIndex = (search.get("editorMode") as TAB_ID) || defaultTab;
  function setSelectedTabIndex(newTab: TAB_ID) {
    const newSearch = new URLSearchParams(search);
    if (newTab === defaultTab) {
      newSearch.delete("editorMode");
    } else {
      newSearch.set("editorMode", newTab);
    }
    setSearch(newSearch);
  }
  // using a `styled(Tab)` seems to confuse blueprint
  const tabStyle = { fontSize: "13px" };

  return (
    <TestPanelContainer>
      <Tabs
        className="bp-header-styled"
        defaultSelectedTabId="primary"
        selectedTabId={selectedTabIndex}
        onChange={(t: TAB_ID) => setSelectedTabIndex(t)}
      >
        <Tab style={tabStyle} id="simple" title="simple mode" />
        <Tab style={tabStyle} id="advanced" title="advanced mode" />
      </Tabs>

      {selectedTabIndex === "advanced" && (
        <TestPanel>
          <RuleEditor />
        </TestPanel>
      )}
      {selectedTabIndex === "simple" && (
        <SecondaryTestPanel>
          <div style={{ position: "relative" }}>
            <div
              style={{
                overflow: "scroll",
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              }}
            >
              <SimpleMode />
            </div>
          </div>
        </SecondaryTestPanel>
      )}
    </TestPanelContainer>
  );
};
